import React from 'react';
import { ContentCard } from '../../molecules/ContentCard';
import { type Content } from '../../../services/contentsService';

export interface ContentsListProps {
  contents: Content[];
  deletingId: number | null;
  onViewReports: (content: Content) => void;
  onDeleteClick: (content: Content) => void;
  onTriggerConversions?: (content: Content) => void;
  triggeringConversionsId?: number | null;
}

export const ContentsList = ({
  contents,
  deletingId,
  onViewReports,
  onDeleteClick,
  onTriggerConversions,
  triggeringConversionsId,
}: ContentsListProps) => {
  return (
    <div className="space-y-4 mb-6">
      {contents.map((content) => (
        <ContentCard
          key={content.id}
          content={content}
          deletingId={deletingId}
          onViewReports={onViewReports}
          onDeleteClick={onDeleteClick}
          onTriggerConversions={onTriggerConversions}
          triggeringConversionsId={triggeringConversionsId}
        />
      ))}
    </div>
  );
};
